import { render, staticRenderFns } from "./blog-detalle.vue?vue&type=template&id=9a17836a"
import script from "./blog-detalle.vue?vue&type=script&lang=js"
export * from "./blog-detalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports